import React from 'react';

import { PageSeo } from 'components/common';
import { LandingPageBlocks } from 'components/landing-page';
import { getBlogLandingPageSeo } from 'helpers/SeoHelpers';
import { useAccessibilityToolbar } from 'hooks/common/useAccessibilityToolbar';
import { useTranslation } from 'hooks/common/useTranslation';
import { useBlogPageProps } from 'hooks/useBlogPageProps';

import { ContentfulLandingPageType, type IContentfulAlphaLandingPage } from 'types';

/* import styles from './AlphaTemplate.module.scss'; */

const ENHANCED_ACCESSIBILITY_SLUGS = [
  'viata-cu-freshful'
];

interface Props {
  isMobilePreview?: boolean,
  data: IContentfulAlphaLandingPage
}

const AlphaTemplate = (props: Props) => {

  const {
    data,
    isMobilePreview
  } = props;

  // Hooks

  const { t } = useTranslation();

  // Props

  const {
    slug,
    title,
    blocks,
    seoTitle,
    seoDescription
  } = data || {};

  const pageSeoProps = getBlogLandingPageSeo(t, { title: seoTitle, description: seoDescription }, isMobilePreview);

  // Context Hooks

  useAccessibilityToolbar({
    enabled: ENHANCED_ACCESSIBILITY_SLUGS.includes(slug)
  });

  useBlogPageProps({ slug, title });

  // Render

  return (
    <>
      <PageSeo {...pageSeoProps} />
      <LandingPageBlocks
        blocks={blocks}
        templateType={ContentfulLandingPageType.Alpha}
        isMobilePreview={isMobilePreview}
      />
    </>
  );
};

export default AlphaTemplate;
